import React from 'react'
import { Box, Grid, Typography } from "@material-ui/core"
import { Trans } from "react-i18next";

export const NextStepBanner = ({ title, icon, style, values }) => {
  return (
    <Box
      style={{
        boxShadow: '0rem 0.5rem 1rem rgba(0, 0, 0, 0.1)',
        padding: '1rem 1.5rem',
        borderRadius: '0.625rem',
        border: '0.0625rem solid #DCF2F4',
        width: '100%',
        ...style,
      }}
    >
      <Grid direction="row" item>
        <Grid item xs={12}>
          <Box className="flex flex-row items-center">
            {icon}
            <Typography style={{ fontWeight: 400, fontSize: '0.875rem', color: '#000000', marginLeft: '1rem', marginBottom: 0 }}>
              <Trans
                i18nKey={title}
                components={{
                  1: <span style={{ fontWeight: 'bold' }} />,
                }}
                values={{...values}}
              />
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}